import React from 'react'
import styled from '@emotion/styled'
import { InfiniteScrollList, List, ListLoader, ListEmpty } from '@labsavvyapp/ui-components'
import { useOrdersetSettingsPageBusinessLogic } from '../../../logic/context'
import { OrdersetListHeader, OrdersetListRow } from './components'
import { Center, isEmpty, Loader, ProjectPackage } from '@labsavvyapp/components'
import { useUserViewModel } from '../../../../../../viewmodels'

const ComponentLayout = styled.div`
  display: flex;
  flex-flow: column nowrap;
  margin: 15px;
  width: 100%;
  height: 100%;
`

export const OrdersetList: React.FC = () => {
  const userViewModel = useUserViewModel()
  const me = userViewModel?.me ?? null
  const pageLogic = useOrdersetSettingsPageBusinessLogic()
  const ordersetList = pageLogic?.ordersetList ?? []
  const ordersetListLoading = pageLogic?.ordersetListLoading ?? false
  const laboratoryList = pageLogic?.laboratoryList ?? []

  const filteredOrdersetList = ordersetList?.filter(
    (orderset) => (orderset.package.is_private && orderset.package.created_by._id === me?._id) || !orderset.package.is_private,
  )

  const handleOrdersetRowClick = (orderset: ProjectPackage) => {
    const { _id } = orderset.package
    pageLogic?.handleUserSelectedOrdersetId(_id)
    pageLogic?.goToEditOrdersetPage(_id)
  }

  if (ordersetListLoading) {
    return (
      <Center>
        <Loader color="violet" size="md" />
      </Center>
    )
  }

  return (
    <List>
      <ComponentLayout>
        <OrdersetListHeader />

        <InfiniteScrollList dataLength={filteredOrdersetList.length} scrollableTarget="orderset-list">
          {!isEmpty(filteredOrdersetList) ? (
            filteredOrdersetList.map((item) => (
              <OrdersetListRow key={item.package._id} projectPackage={item} handleOrdersetRowClick={handleOrdersetRowClick} />
            ))
          ) : laboratoryList.length <= 0 ? (
            <ListEmpty message={'No laboratory configured under this project.'} />
          ) : (
            !ordersetListLoading && <ListEmpty message={'No ordersets found.'} />
          )}
          <ListLoader fetched={filteredOrdersetList.length} total={1} loading={ordersetListLoading} />
        </InfiniteScrollList>
      </ComponentLayout>
    </List>
  )
}
